import { render, staticRenderFns } from "./AnnouncementComponent.vue?vue&type=template&id=6b806e68&"
import script from "./AnnouncementComponent.vue?vue&type=script&lang=js&"
export * from "./AnnouncementComponent.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementComponent.vue?vue&type=style&index=0&id=6b806e68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports